import type { MessageTree } from '../types';

const id = {
  common: {
    appName: 'BatamX Admin',
    platformConsole: 'Konsol Platform',
    admin: 'Admin',
    loading: 'Memuat…',
    save: 'Simpan',
    saveChanges: 'Simpan Perubahan',
    saving: 'Menyimpan…',
    cancel: 'Batal',
    close: 'Tutup',
    add: 'Tambah',
    create: 'Buat',
    edit: 'Ubah',
    update: 'Perbarui',
    delete: 'Hapus',
    deleting: 'Menghapus…',
    duplicate: 'Duplikat',
    remove: 'Hapus',
    confirm: 'Konfirmasi',
    search: 'Cari',
    refresh: 'Segarkan',
    retry: 'Coba Lagi',
    back: 'Kembali',
    discardChanges: 'Batalkan Perubahan',
    logout: 'Keluar',
    view: 'Lihat',
    viewAll: 'Lihat semua',
    yes: 'Ya',
    no: 'Tidak',
    optional: 'Opsional',
    required: 'Wajib',
    total: 'Total',
    actions: 'Tindakan',
    name: 'Nama',
    email: 'Email',
    phone: 'Telepon',
    address: 'Alamat',
    country: 'Negara',
    currency: 'Mata Uang',
    code: 'Kode',
    description: 'Deskripsi',
    position: 'Posisi',
    sequence: 'Urutan',
    type: 'Tipe',
    key: 'Kunci',
    label: 'Label',
    none: 'Tidak ada',
    unknown: 'Tidak diketahui',
    notAvailable: '—',
    noResults: 'Tidak ada hasil. Coba kata pencarian lain.',
    noData: 'Tidak ada data',
    selectPlaceholder: 'Pilih…',
    requiredFieldError: '{field} wajib diisi.',
    saveFailed: 'Gagal menyimpan',
    deleteFailed: 'Gagal menghapus',
    loadFailed: 'Gagal memuat {resource}',
    confirmDelete: 'Hapus "{name}"? Tindakan ini tidak dapat dibatalkan.',
    pagination: {
      showing: 'Menampilkan {from}–{to} dari {total}',
      rowsPerPage: 'Baris per halaman',
      page: 'Halaman {current} dari {total}',
      previous: 'Sebelumnya',
      next: 'Berikutnya',
    },
    status: {
      active: 'Aktif',
      inactive: 'Tidak Aktif',
      hidden: 'Tersembunyi',
      pending: 'Menunggu',
      confirmed: 'Terkonfirmasi',
      completed: 'Selesai',
      cancelled: 'Dibatalkan',
      noShow: 'Tidak Hadir',
      unpaid: 'Belum Dibayar',
      paid: 'Dibayar',
      partial: 'Sebagian',
      overpaid: 'Lebih Bayar',
      void: 'Dibatalkan (Void)',
    },
    roles: {
      owner: 'Pemilik',
      admin: 'Admin',
      batamx: 'BatamX',
      staff: 'Staf',
      customer: 'Pelanggan',
    },
    paymentMethods: {
      cash: 'Tunai',
      credit: 'Kredit',
      debit: 'Debit',
      ewallet: 'E-Wallet',
      bankTransfer: 'Transfer Bank',
      voucher: 'Voucher',
      point: 'Poin',
      other: 'Lainnya',
    },
    months: {
      '1': 'Januari',
      '2': 'Februari',
      '3': 'Maret',
      '4': 'April',
      '5': 'Mei',
      '6': 'Juni',
      '7': 'Juli',
      '8': 'Agustus',
      '9': 'September',
      '10': 'Oktober',
      '11': 'November',
      '12': 'Desember',
    },
    monthsShort: {
      '1': 'Jan',
      '2': 'Feb',
      '3': 'Mar',
      '4': 'Apr',
      '5': 'Mei',
      '6': 'Jun',
      '7': 'Jul',
      '8': 'Agu',
      '9': 'Sep',
      '10': 'Okt',
      '11': 'Nov',
      '12': 'Des',
    },
    days: {
      '0': 'Minggu',
      '1': 'Senin',
      '2': 'Selasa',
      '3': 'Rabu',
      '4': 'Kamis',
      '5': 'Jumat',
      '6': 'Sabtu',
    },
    daysShort: {
      '0': 'Min',
      '1': 'Sen',
      '2': 'Sel',
      '3': 'Rab',
      '4': 'Kam',
      '5': 'Jum',
      '6': 'Sab',
    },
    imageUpload: {
      dragDrop: 'Seret & lepas atau',
      browse: 'jelajahi',
      sizeHint: 'PNG, JPG hingga 5MB',
      replace: 'Ganti',
      remove: 'Hapus',
      newImageSelected: 'Gambar baru dipilih — simpan untuk mengunggah',
      processing: 'Menyiapkan gambar…',
      notImage: 'Silakan pilih gambar PNG atau JPG',
      tooLarge: 'Gambar terlalu besar — gunakan file di bawah 5MB',
      processFailed: 'Gambar tidak dapat dibaca — silakan coba file lain',
    },
    operatingHours: {
      addSlot: '+ Tambah slot',
      noSlots: 'Belum ada slot waktu — klik "+ Tambah slot"',
      closed: 'Tutup',
      to: 'sampai',
      removeSlot: 'Hapus slot',
    },
    footer: {
      copyright: '© {year} BatamX Admin',
      tagline: 'Dibuat untuk admin multi-platform (Booking, E-Commerce, …)',
      platformCopyright: '© {year} BatamX Platform. Hak cipta dilindungi.',
    },
    terms: {
      agreePrefix: 'Dengan melanjutkan, Anda menyetujui',
      termsOfService: 'Syarat Layanan',
      privacyPolicy: 'Kebijakan Privasi',
      terms: 'Syarat',
      privacy: 'Privasi',
      and: 'dan',
    },
    aria: {
      openSidebar: 'Buka sidebar',
      closeSidebar: 'Tutup sidebar',
      sidebarNavigation: 'Navigasi sidebar',
      closeModal: 'Tutup',
      previousMonth: 'Bulan sebelumnya',
      nextMonth: 'Bulan berikutnya',
      removeSlot: 'Hapus slot',
      removeChoice: 'Hapus pilihan',
    },
  },

  nav: {
    brand: {
      name: 'BatamX Admin',
      subtitle: 'Konsol Platform',
    },
    sections: {
      overview: 'Ikhtisar',
      booking: 'Pemesanan',
      maintenance: 'Pemeliharaan',
      configuration: 'Konfigurasi',
      platform: 'Platform',
    },
    items: {
      dashboard: 'Dasbor',
      bookings: 'Pemesanan',
      services: 'Layanan',
      serviceCategories: 'Kategori Layanan',
      customForms: 'Formulir Khusus',
      users: 'Pengguna',
      customers: 'Pelanggan',
      setting: 'Pengaturan',
      appearance: 'Tampilan',
      aboutUs: 'Tentang Kami',
      whatsapp: 'WhatsApp',
      projects: 'Proyek',
    },
  },

  auth: {
    login: {
      title: 'Selamat datang kembali',
      subtitle: 'Masuk ke akun admin Anda untuk melanjutkan.',
      usernameLabel: 'Nama Pengguna',
      usernamePlaceholder: 'Masukkan nama pengguna Anda',
      passwordLabel: 'Kata Sandi',
      rememberMe: 'Ingat saya',
      forgotPassword: 'Lupa kata sandi?',
      submit: 'Masuk',
      submitting: 'Sedang masuk…',
      errorFallback: 'Gagal masuk',
      heroTitleLine1: 'Kelola bisnis Anda',
      heroTitleLine2: 'dengan penuh',
      heroTitleHighlight: 'percaya diri.',
      heroSubtitle: 'Pemesanan, layanan, pelanggan, dan analitik — semua dalam satu dasbor admin yang canggih.',
      featureAnalytics: 'Dasbor & analitik real-time',
      featureBooking: 'Manajemen pemesanan yang mudah',
      featureStaff: 'Manajemen pelanggan & staf',
    },
    register: {
      title: 'Buat akun Anda',
      subtitle: 'Isi detail di bawah ini untuk mulai.',
      fullNameLabel: 'Nama lengkap',
      fullNamePlaceholder: 'Jane Doe',
      emailLabel: 'Email',
      emailPlaceholder: 'anda@perusahaan.com',
      passwordLabel: 'Kata Sandi',
      passwordPlaceholder: 'Buat kata sandi yang kuat',
      passwordHint: 'Harus minimal 6 karakter.',
      submit: 'Buat akun',
      submitting: 'Membuat akun…',
      errorFallback: 'Pendaftaran gagal',
      alreadyHaveAccount: 'Sudah punya akun?',
      signInInstead: 'Masuk saja',
      heroTitleLine1: 'Mulai kelola',
      heroTitleLine2: 'bisnis Anda',
      heroTitleHighlight: 'hari ini.',
      heroSubtitle: 'Buat akun admin Anda dan dapatkan akses ke semua fitur platform secara instan.',
      featureSetup: 'Siap digunakan dalam waktu kurang dari 2 menit',
      featureSecure: 'Aman & terenkripsi secara default',
      featureAccess: 'Akses penuh ke semua fitur',
    },
    resetPassword: {
      checking: 'Memeriksa tautan…',
      title: 'Buat kata sandi baru',
      subtitle: 'Kata sandi baru Anda sebaiknya berbeda dari kata sandi sebelumnya.',
      passwordLabel: 'Kata sandi baru',
      passwordPlaceholder: 'Masukkan kata sandi baru',
      passwordHint: 'Harus minimal 6 karakter.',
      confirmLabel: 'Konfirmasi kata sandi',
      confirmPlaceholder: 'Ulangi kata sandi baru',
      showPassword: 'Tampilkan kata sandi',
      submit: 'Reset kata sandi',
      submitting: 'Menyimpan…',
      rememberedPrompt: 'Sudah ingat kata sandi Anda?',
      backToLogin: 'Kembali ke halaman masuk',
      invalidTitle: 'Tautan tidak valid atau kedaluwarsa',
      invalidBody: 'Minta administrator untuk membuatkan tautan reset yang baru.',
      successTitle: 'Kata sandi diperbarui',
      successBody: 'Sekarang Anda dapat masuk dengan kata sandi baru. Mengalihkan ke halaman masuk…',
      goToLogin: 'Ke halaman masuk',
      errors: {
        passwordMinLength: 'Kata sandi harus minimal 6 karakter.',
        mismatch: 'Kata sandi tidak cocok.',
        failed: 'Reset kata sandi gagal. Silakan coba lagi.',
      },
    },
    brand: {
      name: 'BatamX',
    },
  },

  dashboard: {
    welcomeBack: 'Selamat datang kembali',
    welcomeBackWithName: 'Selamat datang kembali, {name}',
    overviewFor: 'Ikhtisar bisnis untuk {month} {year}.',
    downloadPdf: 'Unduh PDF',
    generatingPdf: 'Membuat…',
    loadFailed: 'Gagal memuat dasbor',
    stats: {
      revenue: 'Pendapatan',
      bookings: 'Pemesanan',
      netProfit: 'Laba Bersih',
      expenses: 'Pengeluaran',
      avgBookingValue: 'Rata-rata Nilai Pemesanan',
      commission: 'Komisi',
      customers: 'Pelanggan',
      staff: 'Staf',
      vsLastMonth: 'vs bulan lalu',
      completed: 'selesai',
      marginSuffix: 'margin {value}%',
      itemsSuffix: '{count} item',
      entriesSuffix: '{count} entri',
      servicesSuffix: '{count} layanan',
    },
    charts: {
      topServices: 'Layanan Terpopuler',
      noDataThisMonth: 'Tidak ada data bulan ini',
      revenueByPayment: 'Pendapatan berdasarkan Pembayaran',
      staffPerformance: 'Performa Staf',
      paymentBreakdown: 'Rincian Pembayaran',
      revenue: 'Pendapatan',
      expensesLabel: 'Pengeluaran',
      paid: 'Dibayar',
      unpaid: 'Belum Dibayar',
      noExpenses: 'Tidak ada pengeluaran',
      bookingsCountAndAmount: '{count} pemesanan · {amount}',
    },
    recentBookings: {
      title: 'Pemesanan Terbaru',
      empty: 'Tidak ada pemesanan terbaru',
      customer: 'Pelanggan',
      service: 'Layanan',
      reservationDate: 'Tanggal Reservasi',
      amount: 'Jumlah',
      status: 'Status',
      walkIn: 'Datang Langsung',
    },
    pdf: {
      title: 'Laporan Bulanan BatamX',
      topServicesNoData: 'Layanan Terpopuler — tidak ada data',
      revenueByPaymentNoData: 'Pendapatan berdasarkan Pembayaran — tidak ada data',
      staffPerformanceNoData: 'Performa Staf — tidak ada data',
      paymentBreakdownNoData: 'Rincian Pembayaran — tidak ada data',
      generatedOn: 'Dibuat pada {datetime}',
    },
  },

  booking: {
    title: 'Pemesanan',
    subtitle: 'Lihat dan kelola pemesanan layanan.',
    loadFailed: 'Gagal memuat pemesanan',
    searchPlaceholder: 'Nama layanan atau pelanggan…',
    loadingBookings: 'Memuat pemesanan…',
    emptyState: 'Tidak ada pemesanan ditemukan.',
    updateFailed: 'Gagal memperbarui pemesanan',
    statusUpdateFailed: 'Gagal memperbarui status',
    minutesSuffix: '{value} menit',
    table: {
      bookingId: 'ID Pemesanan',
      services: 'Layanan',
      customer: 'Pelanggan',
      reservation: 'Reservasi',
      duration: 'Durasi',
      totalPrice: 'Total Harga',
      status: 'Status',
      payment: 'Pembayaran',
      actions: 'Tindakan',
    },
    detail: {
      viewTitle: 'Detail Pemesanan',
      editTitle: 'Ubah Pemesanan',
      bookingId: 'ID Pemesanan',
      customer: 'Pelanggan',
      customerContact: 'Kontak Pelanggan',
      attendedBy: 'Dilayani Oleh',
      reservation: 'Reservasi',
      endTime: 'Waktu Selesai',
      duration: 'Durasi',
      address: 'Alamat',
      external: 'Eksternal',
      status: 'Status',
      payment: 'Pembayaran',
      paymentMethod: 'Metode Pembayaran',
      remark: 'Catatan',
      created: 'Dibuat',
      services: 'Layanan',
      service: 'Layanan',
      price: 'Harga',
      totalPrice: 'Total Harga',
      total: 'Total',
      yes: 'Ya',
    },
    actions: {
      view: 'Lihat',
      edit: 'Ubah',
      cancelBooking: 'Batalkan Pemesanan',
      confirm: 'Konfirmasi',
      complete: 'Selesaikan',
      updating: 'Memperbarui…',
    },
    edit: {
      reservationDateTime: 'Tanggal & Waktu Reservasi',
      status: 'Status',
      paymentStatus: 'Status Pembayaran',
      paymentMethod: 'Metode Pembayaran',
      attendedAddress: 'Alamat Layanan',
      attendedAddressPlaceholder: 'Alamat opsional…',
      externalBooking: 'Pemesanan Eksternal',
      remark: 'Catatan',
      remarkPlaceholder: 'Catatan opsional…',
      servicesSection: 'Layanan',
      addService: '+ Tambah Layanan',
      noServicesAdded: 'Belum ada layanan ditambahkan. Klik "Tambah Layanan" untuk mulai.',
      serviceNumber: 'Layanan #{n}',
      removeService: 'Hapus',
      service: 'Layanan',
      selectService: 'Pilih layanan…',
      deleted: 'Dihapus',
      price: 'Harga',
      attendedByField: 'Dilayani Oleh',
      selectStaff: 'Pilih staf…',
      addStaff: '+ Tambah staf',
      durationCatalog: 'Durasi: {duration} menit · Harga katalog: {price}',
      estimatedTotal: 'Estimasi total: {amount}',
      customerReadOnly: 'Pelanggan:',
      save: 'Simpan Perubahan',
      saving: 'Menyimpan…',
    },
  },

  services: {
    title: 'Layanan',
    subtitle: 'Kelola layanan yang dapat dipesan dan harganya.',
    loadFailed: 'Gagal memuat layanan',
    saveFailed: 'Gagal menyimpan',
    duplicateFailed: 'Gagal menduplikasi',
    deleteFailed: 'Gagal menghapus',
    confirmDuplicate: 'Duplikasi "{title}"? Salinan akan dibuat sebagai tidak aktif.',
    confirmDelete: 'Hapus "{title}"? Tindakan ini tidak dapat dibatalkan.',
    addService: 'Tambah layanan',
    editService: 'Ubah layanan',
    reorder: 'Atur Ulang',
    reorderTitle: 'Atur Ulang Layanan',
    reorderSubtitle: 'Seret dan lepas untuk mengatur urutan tampilan.',
    saveOrder: 'Simpan Urutan',
    savedOrderFor: 'Urutan disimpan untuk {count} layanan.',
    saveOrderFailed: 'Gagal menyimpan urutan',
    unsavedChanges: 'Anda memiliki perubahan yang belum disimpan. Klik "Simpan Urutan" untuk menyimpannya.',
    noServicesInCategory: 'Tidak ada layanan pada kategori ini.',
    category: 'Kategori',
    allCategories: 'Semua kategori',
    uncategorized: 'Tidak Berkategori',
    searchPlaceholder: 'Cari berdasarkan judul atau kode…',
    loadingServices: 'Memuat layanan…',
    minutesSuffix: '{value} menit',
    table: {
      position: 'Pos',
      title: 'Judul',
      code: 'Kode',
      type: 'Tipe',
      price: 'Harga',
      duration: 'Durasi',
      status: 'Status',
      actions: 'Tindakan',
    },
    sections: {
      basicInfo: 'Info Dasar',
      pricing: 'Harga',
      description: 'Deskripsi',
      staffAvailability: 'Staf & Ketersediaan',
      validityPeriod: 'Periode Berlaku',
      subscription: 'Langganan',
    },
    fields: {
      image: 'Gambar',
      title: 'Judul',
      titlePlaceholder: 'cth. Pijat Seluruh Tubuh',
      code: 'Kode',
      codePlaceholder: 'cth. SVC-001',
      serviceType: 'Tipe Layanan',
      noneOption: '— Tidak ada —',
      status: 'Status',
      position: 'Posisi',
      positionPlaceholder: 'Urutan tampilan (cth. 1, 2, 3)',
      positionHint: 'Angka lebih kecil muncul lebih dulu. Gunakan mode Atur Ulang untuk seret-lepas.',
      price: 'Harga',
      currency: 'Mata Uang',
      commissionPercentage: 'Komisi (%)',
      commissionPlaceholder: 'cth. 10',
      durationMinutes: 'Durasi (menit)',
      durationPlaceholder: 'cth. 60',
      descriptionPlaceholder: 'Deskripsi layanan yang ditampilkan kepada pelanggan…',
      remark: 'Catatan',
      remarkPlaceholder: 'Catatan internal (tidak ditampilkan kepada pelanggan)',
      allowedStaff: 'Staf yang diizinkan',
      noStaffSelected: 'Tidak ada staf dipilih — semua staf dapat melayani',
      allowExternalBooking: 'Izinkan pemesanan eksternal',
      allowExternalBookingHint: 'Pelanggan dapat memesan layanan ini melalui portal',
      validFrom: 'Berlaku dari',
      validTo: 'Berlaku sampai',
      subscriptionService: 'Layanan berlangganan',
      subscriptionServiceHint: 'Pelanggan membayar sekali dan dapat memesan berkali-kali',
      usageLimit: 'Batas penggunaan',
      usageLimitPlaceholder: 'cth. 10',
      expiryDays: 'Masa berlaku (hari)',
      expiryDaysPlaceholder: 'cth. 30',
    },
    validation: {
      titleRequired: 'Judul wajib diisi.',
      codeRequired: 'Kode wajib diisi.',
      priceInvalid: 'Harga harus berupa angka non-negatif yang valid.',
    },
  },

  categories: {
    title: 'Kategori Layanan',
    subtitle: 'Kelola tipe layanan dan urutan tampilannya.',
    loadFailed: 'Gagal memuat kategori',
    addCategory: 'Tambah kategori',
    editCategory: 'Ubah kategori',
    categoryCreated: 'Kategori berhasil dibuat.',
    categoryUpdated: 'Kategori berhasil diperbarui.',
    categoryDeleted: 'Kategori berhasil dihapus.',
    confirmDelete: 'Hapus "{name}"? Tindakan ini tidak dapat dibatalkan.',
    saveFailed: 'Gagal menyimpan',
    deleteFailed: 'Gagal menghapus',
    searchPlaceholder: 'Cari berdasarkan nama…',
    loadingCategories: 'Memuat kategori…',
    table: {
      name: 'Nama',
      position: 'Posisi',
      services: 'Layanan',
      actions: 'Tindakan',
    },
    fields: {
      image: 'Gambar',
      name: 'Nama',
      namePlaceholder: 'cth. Pijat, Kebersihan',
      position: 'Posisi',
      positionPlaceholder: 'Urutan tampilan (cth. 1, 2, 3)',
      positionHint: 'Angka lebih kecil muncul lebih dulu.',
    },
    validation: {
      nameRequired: 'Nama wajib diisi.',
      positionInvalid: 'Posisi harus berupa angka non-negatif.',
    },
  },

  customForms: {
    title: 'Formulir Khusus',
    subtitle: 'Kelola bidang formulir khusus untuk pemesanan layanan.',
    loadFailed: 'Gagal memuat formulir khusus',
    saveFailed: 'Gagal menyimpan',
    deleteFailed: 'Gagal menghapus',
    addField: 'Tambah bidang',
    addFormField: 'Tambah bidang formulir khusus',
    editFormField: 'Ubah bidang formulir khusus',
    confirmDelete: 'Hapus formulir khusus "{label}"? Tindakan ini tidak dapat dibatalkan.',
    searchPlaceholder: 'Cari berdasarkan kunci atau label…',
    loadingForms: 'Memuat formulir khusus…',
    table: {
      key: 'Kunci',
      label: 'Label',
      type: 'Tipe',
      required: 'Wajib',
      sequence: 'Urutan',
      actions: 'Tindakan',
    },
    fields: {
      key: 'Kunci',
      keyPlaceholder: 'cth. ukuran_baju',
      label: 'Label',
      labelPlaceholder: 'cth. Ukuran Baju',
      sequence: 'Urutan',
      type: 'Tipe',
      choices: 'Pilihan',
      choicePlaceholder: 'Pilihan {n}',
      addChoice: '+ Tambah pilihan',
      required: 'Wajib',
      applyToAllServices: 'Terapkan ke semua layanan',
      services: 'Layanan',
      selectServicesPlaceholder: 'Pilih layanan…',
      noServicesAvailable: 'Tidak ada layanan tersedia',
      instruction: 'Instruksi',
      instructionPlaceholder: 'Teks bantuan opsional yang ditampilkan kepada pelanggan…',
    },
    typeOptions: {
      input: 'Input',
      choices: 'Pilihan',
      number: 'Angka',
      date: 'Tanggal',
      dob: 'Tanggal Lahir',
    },
    validation: {
      keyRequired: 'Kunci wajib diisi.',
      labelRequired: 'Label wajib diisi.',
      choicesRequired: 'Minimal satu pilihan diperlukan untuk tipe "Pilihan".',
    },
  },

  users: {
    title: 'Pengguna',
    subtitle: 'Kelola pengguna admin dan staf.',
    loadFailed: 'Gagal memuat pengguna',
    saveFailed: 'Gagal menyimpan',
    deleteFailed: 'Gagal menghapus',
    addUser: 'Tambah pengguna',
    editUser: 'Ubah pengguna',
    confirmDelete: 'Hapus "{name}"? Tindakan ini tidak dapat dibatalkan.',
    searchPlaceholder: 'Cari berdasarkan nama, email, peran, status…',
    loadingUsers: 'Memuat pengguna…',
    table: {
      name: 'Nama',
      email: 'Email',
      phone: 'Telepon',
      role: 'Peran',
      status: 'Status',
      actions: 'Tindakan',
    },
    sections: {
      profilePicture: 'Foto Profil',
      account: 'Akun',
      contact: 'Kontak',
      professional: 'Profesional',
    },
    fields: {
      photo: 'Foto',
      profileDisplay: 'Tampilkan Profil',
      performService: 'Melayani Layanan',
      name: 'Nama',
      namePlaceholder: 'Jane Doe',
      title: 'Jabatan',
      titlePlaceholder: 'cth. Manajer, Terapis',
      username: 'Nama Pengguna',
      usernamePlaceholder: 'Default ke email',
      email: 'Email',
      emailPlaceholder: 'jane@perusahaan.com',
      password: 'Kata Sandi',
      passwordPlaceholder: 'Minimal 6 karakter',
      role: 'Peran',
      status: 'Status',
      phone: 'Telepon',
      phonePlaceholder: '+628xxx',
      country: 'Negara',
      countryPlaceholder: 'ID',
      address: 'Alamat',
      addressPlaceholder: 'Alamat lengkap',
      service: 'Layanan Konsultasi',
      servicePlaceholder: 'cth. Konsultasi gizi, Fisioterapi',
      occupation: 'Pekerjaan',
      occupationPlaceholder: 'cth. Terapis',
      description: 'Deskripsi',
      descriptionPlaceholder: 'Bio atau deskripsi singkat',
    },
    validation: {
      nameRequired: 'Nama wajib diisi.',
      emailInvalid: 'Email yang valid wajib diisi.',
      passwordMinLength: 'Kata sandi harus minimal 6 karakter.',
    },
    resetPassword: {
      action: 'Tautan reset',
      generating: 'Membuat…',
      title: 'Tautan reset kata sandi',
      description: 'Bagikan tautan ini kepada {name} agar dapat membuat kata sandi baru.',
      copy: 'Salin',
      copied: 'Tautan disalin ke papan klip.',
      copyHint: 'Pilih tautan di atas untuk menyalinnya secara manual.',
      expiryNote: 'Tautan berlaku 24 jam dan menggantikan tautan yang dibuat sebelumnya.',
      failed: 'Tautan reset gagal dibuat.',
    },
  },

  customers: {
    title: 'Pelanggan',
    subtitle: 'Kelola akun pelanggan.',
    loadFailed: 'Gagal memuat pelanggan',
    saveFailed: 'Gagal menyimpan',
    addCustomer: 'Tambah pelanggan',
    editCustomer: 'Ubah pelanggan',
    searchPlaceholder: 'Cari berdasarkan nama, email, telepon…',
    loadingCustomers: 'Memuat pelanggan…',
    table: {
      name: 'Nama',
      email: 'Email',
      phone: 'Telepon',
      dob: 'Tgl Lahir',
      status: 'Status',
      actions: 'Tindakan',
      createdOn: 'Dibuat {date}',
    },
    sections: {
      account: 'Akun',
      personalInfo: 'Info Pribadi',
    },
    fields: {
      name: 'Nama',
      namePlaceholder: 'Jane Doe',
      email: 'Email',
      emailPlaceholder: 'jane@contoh.com',
      username: 'Nama Pengguna',
      usernamePlaceholder: 'jane.doe (default ke email)',
      password: 'Kata Sandi',
      passwordPlaceholder: 'Minimal 6 karakter',
      dob: 'Tanggal Lahir',
      phone: 'Telepon',
      phonePlaceholder: '+628xxx',
      country: 'Negara',
      countryPlaceholder: 'ID',
      type: 'Tipe',
      typePlaceholder: 'cth. VIP, Reguler',
      address: 'Alamat',
      addressPlaceholder: 'Alamat lengkap',
    },
    validation: {
      nameRequired: 'Nama wajib diisi.',
      emailInvalid: 'Email yang valid wajib diisi.',
      passwordMinLength: 'Kata sandi harus minimal 6 karakter.',
    },
  },

  projects: {
    title: 'Proyek',
    subtitle: 'Kelola semua proyek tenant di platform.',
    loadFailed: 'Gagal memuat proyek',
    saveFailed: 'Gagal menyimpan',
    switchFailed: 'Gagal beralih proyek',
    addProject: 'Tambah proyek',
    editProject: 'Ubah proyek',
    confirmSwitch: 'Beralih ke proyek "{name}"? Halaman akan dimuat ulang.',
    searchPlaceholder: 'Cari berdasarkan nama, kode, sektor…',
    loadingProjects: 'Memuat proyek…',
    table: {
      name: 'Nama',
      code: 'Kode',
      sector: 'Sektor',
      contact: 'Kontak',
      country: 'Negara',
      test: 'Uji Coba',
      status: 'Status',
      actions: 'Tindakan',
    },
    badges: {
      test: 'Uji Coba',
      // Not 'Aktif': the status column beside it uses that for an enabled project.
      live: 'Produksi',
      active: 'Aktif',
      disabled: 'Nonaktif',
    },
    toast: {
      enabled: '"{name}" diaktifkan — situs booking-nya kembali online.',
      disabled: '"{name}" dinonaktifkan — situs booking-nya kini offline.',
    },
    rowActions: {
      roles: 'Peran',
      edit: 'Ubah',
      access: 'Akses',
    },
    fields: {
      name: 'Nama',
      namePlaceholder: 'cth. Batam Spa & Wellness',
      code: 'Kode',
      codePlaceholder: 'cth. BSW',
      description: 'Deskripsi',
      descriptionPlaceholder: 'Deskripsi singkat (opsional)',
      sector: 'Sektor',
      sectorPlaceholder: 'cth. Kesehatan, F&B, Ritel',
      address: 'Alamat',
      addressPlaceholder: 'Alamat bisnis (opsional)',
      email: 'Email',
      emailPlaceholder: 'Email kontak (opsional)',
      contactPerson: 'Nama Kontak',
      contactPersonPlaceholder: 'Nama orang yang dapat dihubungi',
      contactNo: 'Nomor Kontak',
      contactNoPlaceholder: 'cth. +62 812 3456 7890',
      country: 'Negara',
      currency: 'Mata Uang',
      testProject: 'Proyek uji coba',
      activeProject: 'Proyek aktif',
      activeProjectHint: 'Saat dinonaktifkan, situs booking tidak lagi menemukan proyek ini dan menampilkan Not Found. Akses admin tidak terpengaruh.',
    },
    countries: {
      id: 'Indonesia',
      sg: 'Singapura',
      my: 'Malaysia',
    },
    validation: {
      nameRequired: 'Nama wajib diisi.',
      codeRequired: 'Kode wajib diisi.',
      sectorRequired: 'Sektor wajib diisi.',
      contactPersonRequired: 'Nama kontak wajib diisi.',
      contactNoRequired: 'Nomor kontak wajib diisi.',
    },
    seedRoles: {
      title: 'Peran akses',
      subtitle: 'Setiap peran dibuat dengan login sendiri. Kata sandi diatur saat login pertama.',
      bookingHint:
        'Booking aktif: 2 kategori contoh dengan 1 layanan masing-masing akan dibuat, beserta jam onsite & offsite yang buka setiap hari (09.00–18.00).',
    },
    roles: {
      title: 'Peran — {project}',
      addRole: 'Tambah peran',
      editRole: 'Ubah peran',
      loadingRoles: 'Memuat peran…',
      rolesConfigured: '{count} peran dikonfigurasi',
      noRolesConfigured: 'Belum ada peran yang dikonfigurasi. Buat satu untuk mulai.',
      roleName: 'Nama Peran',
      roleNamePlaceholder: 'cth. admin, staf, manajer',
      modulePermissions: 'Izin Modul',
      roleCreated: 'Peran berhasil dibuat.',
      roleUpdated: 'Peran berhasil diperbarui.',
      roleDeleted: 'Peran berhasil dihapus.',
      confirmDelete: 'Hapus peran "{role}"? Tindakan ini tidak dapat dibatalkan.',
      loadFailed: 'Gagal memuat peran',
      saveFailed: 'Gagal menyimpan',
      deleteFailed: 'Gagal menghapus',
      roleNameRequired: 'Nama peran wajib diisi.',
      enabled: 'Aktif',
      disabled: 'Nonaktif',
      modules: {
        dashboard: 'Dasbor',
        booking: 'Pemesanan',
        ecommerce: 'E-commerce',
        user: 'Pengguna',
        customer: 'Pelanggan',
        notification: 'Notifikasi',
        custom: 'Khusus',
        reward: 'Hadiah',
        rental: 'Sewa',
        project: 'Proyek',
      },
    },
  },

  settings: {
    title: 'Pengaturan Proyek',
    subtitle: 'Kelola konfigurasi umum, pemesanan, dan preferensi notifikasi.',
    loadFailed: 'Gagal memuat pengaturan',
    saveFailed: 'Gagal menyimpan pengaturan',
    saveSuccess: 'Pengaturan berhasil disimpan',
    reloadFailed: 'Gagal memuat ulang',
    sections: {
      general: {
        title: 'Umum',
        subtitle: 'Pengaturan akses inti dan perpesanan',
      },
      contactInformation: {
        title: 'Informasi Kontak',
        subtitle: 'Alamat dan detail kontak yang ditampilkan kepada pelanggan',
      },
      bookingConfiguration: {
        title: 'Konfigurasi Pemesanan',
        subtitle: 'Kontrol tipe pemesanan, label, dan interval operasional',
      },
      operatingHours: {
        title: 'Jam Operasional',
        subtitle: 'Jadwal mingguan untuk pemesanan offsite dan onsite',
      },
      additionalSettings: {
        title: 'Pengaturan Tambahan',
        subtitle: 'Tarif komisi dan template notifikasi',
      },
    },
    dividers: {
      information: 'Informasi',
      booking: 'Pemesanan',
      operatingHours: 'Jam Operasional',
      others: 'Lainnya',
    },
    fields: {
      allowCustomerLogin: 'Izinkan Login Pelanggan',
      allowCustomerLoginHint: 'Aktifkan pelanggan untuk masuk ke aplikasi publik',
      productSectionEnabled: 'Tampilkan Bagian Produk',
      productSectionEnabledHint: 'Tampilkan katalog produk di halaman utama aplikasi publik',
      motto: 'Motto',
      mottoPlaceholder: 'Motto proyek Anda',
      welcomeMessage: 'Pesan Selamat Datang',
      welcomeMessagePlaceholder: 'Pesan selamat datang untuk pelanggan',
      address: 'Alamat',
      addressPlaceholder: 'Alamat bisnis lengkap',
      addressLink: 'Tautan Alamat',
      addressLinkPlaceholder: 'URL Google Maps atau sejenisnya',
      contactNo: 'Nomor Kontak',
      contactNoPlaceholder: '+65 1234 5678',
      contactEmail: 'Email Kontak',
      contactEmailPlaceholder: 'contact@contoh.com',
      allowOffsiteBooking: 'Izinkan Pemesanan Offsite',
      allowOffsiteBookingHint: 'Pelanggan dapat memesan layanan secara offsite',
      allowOnsiteBooking: 'Izinkan Pemesanan Onsite',
      allowOnsiteBookingHint: 'Pelanggan dapat memesan layanan di lokasi Anda',
      offsiteLabel: 'Label Offsite',
      offsiteLabelPlaceholder: 'cth. Pengiriman, Layanan Rumah',
      onsiteLabel: 'Label Onsite',
      onsiteLabelPlaceholder: 'cth. Datang Langsung, Di Toko',
      defaultLanguage: 'Bahasa Default',
      defaultLanguageHint: 'Bahasa yang dipakai situs pemesanan untuk pengunjung yang belum memilih sendiri.',
      defaultLanguageAuto: 'Ikuti pengunjung / negara proyek',
      defaultLanguageEn: 'English',
      defaultLanguageId: 'Bahasa Indonesia',
      remarksLabel: 'Label Catatan',
      remarksLabelPlaceholder: 'cth. Catatan, Permintaan khusus',
      offsiteInterval: 'Interval Operasi Offsite',
      offsiteIntervalPlaceholder: 'cth. 30 (menit)',
      onsiteInterval: 'Interval Operasi Onsite',
      onsiteIntervalPlaceholder: 'cth. 30 (menit)',
      commissionPercentage: 'Komisi Pemesanan (%)',
      commissionPercentagePlaceholder: 'cth. 10',
      invoiceNotes: 'Catatan Faktur',
      invoiceNotesPlaceholder: 'Catatan yang ditampilkan pada faktur',
    },

    whatsapp: {
      title: 'Notifikasi WhatsApp',
      subtitle: 'Isi pesan dan tombol aktif/nonaktif untuk setiap pesan yang dapat dikirim staf.',
      manualHint: 'Pesan tidak pernah terkirim otomatis. Mengaktifkan sebuah notifikasi menambahkan tombol di aplikasi yang membuka WhatsApp dengan pesan siap pakai — staf tetap menekan kirim. Perubahan muncul di aplikasi saat staf membuka kembali halaman terkait.',
      loadFailed: 'Gagal memuat notifikasi',
      saveSuccess: 'Notifikasi tersimpan',
      saveFailed: 'Gagal menyimpan notifikasi',
      resetSuccess: 'Teks bawaan dikembalikan',
      resetFailed: 'Gagal mengembalikan teks bawaan',
      resetToDefault: 'Kembalikan ke bawaan',
      customised: 'Diubah',
      message: 'Pesan',
      variables: 'Sisipkan data',
      showPreview: 'Lihat pratinjau',
      hidePreview: 'Sembunyikan pratinjau',
      previewEmpty: 'Belum ada yang dapat ditampilkan.',
      tooLong: 'Persingkat menjadi maksimal {max} karakter untuk menyimpan.',
      on: 'Aktif',
      off: 'Nonaktif',
      groupCount: '{enabled} dari {total} aktif',
      groups: {
        booking: 'Pemesanan',
        rental: 'Sewa',
        customer: 'Pelanggan',
      },
      templates: {
        'booking.confirmed': 'Pemesanan dikonfirmasi',
        'booking.reminder': 'Pengingat pemesanan',
        'booking.invoice': 'Faktur pemesanan',
        'booking.completed': 'Pemesanan selesai',
        'booking.rescheduled': 'Jadwal pemesanan diubah',
        'booking.cancelled': 'Pemesanan dibatalkan',
        'booking.staffAssignment': 'Penugasan staf',
        'rental.paymentDue': 'Sewa jatuh tempo',
        'rental.paymentOverdue': 'Sewa terlambat',
        'rental.leaseExpiring': 'Masa sewa akan berakhir',
        'rental.invoice': 'Faktur sewa',
        'rental.leaseConfirmed': 'Sewa dimulai',
        'rental.paymentReceived': 'Pembayaran diterima',
        'rental.returnSummary': 'Ringkasan pengembalian',
        'rental.depositReceived': 'Deposit diterima',
        'customer.bookingLink': 'Tautan pemesanan pribadi',
        'customer.welcome': 'Pesan selamat datang',
      },
      descriptions: {
        'booking.confirmed': 'Dikirim saat pemesanan tertunda dikonfirmasi dan staf ditugaskan.',
        'booking.reminder': 'Pengingat pemesanan mendatang, biasanya dikirim sehari sebelumnya.',
        'booking.invoice': 'Mengirim tautan faktur pemesanan.',
        'booking.completed': 'Ucapan terima kasih setelah pemesanan ditandai selesai.',
        'booking.rescheduled': 'Dikirim saat tanggal atau jam pemesanan berubah.',
        'booking.cancelled': 'Dikirim saat pemesanan dibatalkan.',
        'booking.staffAssignment': 'Dikirim ke staf yang ditugaskan, bukan ke pelanggan.',
        'rental.paymentDue': 'Pengingat pembayaran sewa yang akan atau sedang jatuh tempo.',
        'rental.paymentOverdue': 'Penagihan pembayaran sewa yang telah lewat jatuh tempo.',
        'rental.leaseExpiring': 'Tawaran perpanjangan untuk sewa yang akan berakhir.',
        'rental.invoice': 'Mengirim tautan faktur sewa.',
        'rental.leaseConfirmed': 'Dikirim saat sewa menjadi aktif, biasanya tepat setelah serah terima.',
        'rental.paymentReceived': 'Tanda terima saat pembayaran sewa ditandai lunas.',
        'rental.returnSummary': 'Ringkasan penutup saat aset dikembalikan, termasuk pengembalian dana.',
        'rental.depositReceived': 'Tanda terima saat deposit sewa ditandai lunas.',
        'customer.bookingLink': 'Membagikan tautan pemesanan pribadi pelanggan bersama kode QR.',
        'customer.welcome': 'Sapaan untuk pelanggan yang baru terdaftar.',
      },
    },
    scheduleTypes: {
      offsite: 'Jadwal Offsite',
      onsite: 'Jadwal Onsite',
    },
  },

  appearance: {
    title: 'Tampilan',
    subtitle: 'Kelola merek, gambar, dan skema warna proyek Anda.',
    sections: {
      brandImages: {
        title: 'Gambar Merek',
        subtitle: 'Gambar sampul dan logo yang ditampilkan di aplikasi pelanggan',
      },
      brandColors: {
        title: 'Warna Merek',
        subtitle: 'Skema warna yang digunakan pada aplikasi pelanggan',
      },
    },
    dividers: {
      colors: 'Warna',
    },
    fields: {
      coverImage: 'Gambar Sampul',
      logo: 'Logo',
      themeColor: 'Warna Tema',
      buttonColor: 'Warna Tombol',
      serviceColor: 'Warna Layanan',
    },
  },

  aboutUs: {
    title: 'Tentang Kami',
    subtitle: 'Kelola konten Tentang Kami yang ditampilkan kepada pelanggan.',
    enableToggle: 'Aktifkan Tentang Kami',
    enableToggleHint: 'Tampilkan bagian Tentang Kami di aplikasi pelanggan',
    sectionNumber: 'Bagian {n}',
    removeSection: 'Hapus',
    addSection: '+ Tambah Bagian Baru',
    sectionImage: 'Gambar Bagian',
    sectionTitle: 'Judul',
    sectionTitlePlaceholder: 'Judul bagian',
    sectionContentLabel: 'Konten',
    sectionContentPlaceholder: 'Tulis konten bagian ini…',
    loadFailed: 'Gagal memuat pengaturan Tentang Kami',
    saveFailed: 'Gagal menyimpan Tentang Kami',
    saveSuccess: 'Tentang Kami berhasil disimpan',
  },
} satisfies MessageTree;

export default id;
